var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM10.5 7.66992C10.1906 7.49135 9.80936 7.49135 9.5 7.66992C9.19063 7.84856 9 8.17888 9 8.53613V15.4639C9.00004 15.821 9.1907 16.1514 9.5 16.3301C9.80938 16.5087 10.1906 16.5087 10.5 16.3301L16.5 12.8662C16.8094 12.6876 17 12.3572 17 12C16.9999 11.6428 16.8093 11.3124 16.5 11.1338L10.5 7.66992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFill);
export default __webpack_public_path__ + "static/media/play-fill.1624fd298cb067b561d0b4e995241c43.svg";
export { ForwardRef as ReactComponent };